// import(/* webpackChunkName: "header" */'@patsnap-utils/header');
// import(/* webpackChunkName: "header" */'@patsnap-biz/header/lib/style');
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';
// import '@babel/polyfill';
// eslint-disable-next-line
[].startsWith;
import(/* webpackChunkName: "insights" */'./app.js');
